import React, { useState } from "react";
import { Link } from "react-router-dom";

function NavBar() {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

  return (
    <nav style={styles.navContainer}>
      <ul style={styles.ul}>
        <li style={styles.li}>
          <Link to="/" style={styles.link}>Home</Link>
        </li>
        <li style={styles.li}>
          <Link to="/posts" style={styles.link}>Posts</Link>
        </li>
        <li style={styles.li}>
          <Link to="/apps" style={styles.link}>Apps</Link>
        </li>
        <li style={styles.li}>
          <Link to="/sim" style={styles.link}>Sim</Link>
        </li>
        <li
          style={{ ...styles.li, position: "relative" }}
          onMouseEnter={toggleDropdown}
          onMouseLeave={toggleDropdown}
        >
          <button style={styles.dropdownButton}>Info</button>
          {isDropdownOpen && (
            <ul style={styles.dropdownMenu}>
              <li style={styles.dropdownItem}>
                <Link to="/about" style={styles.link}>About</Link>
              </li>
              <li style={styles.dropdownItem}>
                <Link to="/privacy-policy" style={styles.link}>Privacy Policy</Link>
              </li>
              <li style={styles.dropdownItem}>
                <Link to="/support" style={styles.link}>Support</Link>
              </li>
            </ul>
          )}
        </li>
      </ul>
    </nav>
  );
}

const styles = {
  navContainer: {
    background: "black",
    padding: "1rem",
  },
  ul: {
    listStyleType: "none",
    display: "flex",
    gap: "1rem",
    margin: 0,
    padding: 0,
  },
  li: {
    position: "relative",
  },
  link: {
    color: "var(--text-color)",
    textDecoration: "none",
  },
  dropdownButton: {
    background: "none",
    border: "none",
    color: "var(--text-color)",
    cursor: "pointer",
    fontSize: "1rem",
    padding: 0, // Remove default button padding
    margin: 0, // Ensure no extra margin
    textDecoration: "none", // Match link style
    lineHeight: "inherit", // Match line height of links
    fontFamily: "inherit", // Ensure font consistency
  },
  dropdownMenu: {
    background: "black",
    listStyleType: "none",
    padding: "0.5rem 1.5rem",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    zIndex: 1000,
  },
  dropdownItem: {
    margin: "0.5rem 0",
  },
};

export default NavBar;